import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import { GuestDashboard } from './pages';
const App = React.lazy(() => import('./App'));

import './fonts/fonts.css';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <>
      {window.location.href.startsWith(
        process.env.REACT_APP_PUBLIC_DASHBOARD_VIEWER_ROOT as string
      ) ? (
        <GuestDashboard />
      ) : (
        <App />
      )}
    </>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
